import React, { useEffect, useState, useRef, useMemo, forwardRef } from 'react'
import './index.less'
// import JSBridge from '@xpeng/js-bridge'
import {
  jumpPage,
  wxInit,
  myInit,
  formatTs,
  navHide,
  closeWindow,
  isInViewPort,
  priceFormat,
  loadScript
} from '../../../../utils/common';
import { goToPage, formatPrice, defineSelfShareAction } from '../../utils'
import {
  ErrorPlaceholder,
  EmptyPlaceholder,
} from "../../../../components/placeholder"
import OpenBar from '../../../../components/open-bar';
// import PullDownWrapper from '../../../../components/pull-down-wrapper'
import SharePanel from "../../../../components/share-panel"
import LoadingPage from "../../../../components/loading-page"
import Toast from '../../../../components/toast'
import PopupBottomModal from '../../../../components/popup-bottom-modal'
import FullScreenPopup from '../../components/full-screen-popup'
import { getCurrentUid, GetUserCredit } from '../../../../api/web-h5-common'
import StationDetailItem from '../../../../components/station-item'
import {
  GetMyMemberGoods,
  GetUserMembership,
  GetXpOwnerPrivilege,
  GetMemberCardGoods,
  GetMemberGoods,
  PostPreBuyMemberGoods,
  GetQueryStationList,
  queryDiscountCouponPage,
  getCurrentUserInfo
} from '../../api'
import {
  MemberGoods,
  MemberCardGood,
  CouponPackGood,
  GoodsTabContent
} from '../../types'
import { MALL_ENTRY, DEFAULT_ERROR_MSG } from '../../config';
import { trackGdp } from '../../../../utils/gio-report';
import { P_MALL_APPID } from '../../../../utils/constants';
import VipCouponCard from '../../../../components/vip-coupon-card';
import MemberGoodslist from '../../components/member-goods-list';
import AgreementRow from '../../components/agreement-row';
import ShortMemberGoodslist from '../../components/short-member-goods-list';

const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'

/**
 * 价格展示逻辑：现金价 | 现金价+组合价 | 现金价+积分价 | 积分价
 * 先判断积分余额是否展示（是否车主身份+积分余额），再看商品支不支持积分（商品信息+前面结果）决定最终展示
 */
const payModeShowType = (payMode, isXpCarOwner, credit) => {
  const PAY_MODE = {
    1: 'pure-rmb',
    2: 'pure-credit',
    3: 'mix'
  }

  if (!isXpCarOwner && credit <= 0 && payMode === 3) {
    return PAY_MODE[1]
  }

  return PAY_MODE[payMode]
}

const getGroupType = (data, userData, newShowGoodType) => {
  if (
    newShowGoodType === 1
    &&
    (data?.couponPackGoodsList?.length > 0 || data?.chargeCardGoodsList?.length > 0)
    &&
    userData?.userCouponList?.length === 0
    &&
    userData?.userChargeCardList?.length === 0
  ) {
    if (data?.couponPackGoodsList?.length) {
      if (data?.chargeCardGoodsList?.length) {
        return data?.priorGoodsType === 2 ? '2个Tab（优先级VIP券包）' : '2个Tab（优先级VIP电卡）'
      } else {
        return '1个Tab（VIP券包）'
      }
    } else {
      if (data?.chargeCardGoodsList?.length) {
        return '1个Tab（VIP电卡）'
      }
    }
  } else if (userData?.userCouponList?.length !== 0
    ||
    userData?.userChargeCardList?.length !== 0) {
    if (data?.couponPackGoodsList?.length) {
      if (data?.chargeCardGoodsList?.length) {
        return data?.priorGoodsType === 2 ? '2个Tab（优先级VIP券包）' : '2个Tab（优先级VIP电卡）'
      } else {
        return '1个Tab（VIP券包）'
      }
    } else {
      if (data?.chargeCardGoodsList?.length) {
        return '1个Tab（VIP电卡）'
      }
    }
  } else {
    return null
  }
}

const getPointsType = (good) => {
  return (!good?.showDiscountBuy && !!good?.maxUseCreditAmount) ? '显示积分价' : '未显示积分价'
}

const getUnitPriceType = (good) => {
  if (good?.showDiscountBuy) {
    return '抵扣红包后优惠价+划线价'
  } else {
    if (good?.maxUseCreditAmount) {
      return '无单价显示'
    } else {
      return '原价'
    }
  }
}

export const getSystemMallCoupon = (good) => {
  if (good?.autoReceiveDiscountCoupon) {
    if (good?.showDiscountCouponLabel) {
      return '需代领商城券'
    }
  } else {
    if (good?.showDiscountCouponLabel) {
      return '需代领商城券（代领成功）'
    } else {
      return '无代领商城券'
    }
  }
}

const NavBar = forwardRef(
  function Nav({ callShare, bgWhite = false }: any, ref: React.Ref<HTMLDivElement>) {
    return (
      <div className={`vip-nav-bar ${bgWhite ? 'bg-white' : ''}`} ref={ref}>
        {
          bgWhite
            ?
            <img src={require('../../assets/back.png')} alt='' className='icon' onClick={closeWindow} />
            :
            <img src={`${CHARGE_CDN}/common/back_white.png`} alt='' className='icon' onClick={closeWindow} />
        }
        <span className={`title ${bgWhite ? 'title-black' : ''}`}>充电VIP</span>
        {
          bgWhite
            ?
            <img src={require('../../assets/share.png')} alt='' className='icon' onClick={callShare} />
            :
            <img src={`${CHARGE_CDN}/common/share_white.png`} alt='' className='icon' onClick={callShare} />}
      </div>
    )
  }
)

interface TabItem {
  key: string
  title: string
  type: string
  subTitle?: string
  onClick: () => void
}

interface Props {
  firstShowTabKey?: string
  showSubTitle?: boolean
  showIcon?: boolean
  tabItems: TabItem[]
  className?: string
  changeActiveTab?: (tab: any) => void
}

const TabsBar = React.memo(function App(
  { firstShowTabKey, showSubTitle = true, tabItems, className = '', changeActiveTab, showIcon }: Props
) {
  const [hlTab, setHlTab] = useState(firstShowTabKey || tabItems[0]?.key || '')

  const clickTab = (tabItem: TabItem) => {
    setHlTab(tabItem?.key)
    tabItem?.onClick()
  }
  useEffect(() => {
    changeActiveTab && changeActiveTab(hlTab)
  }, [hlTab])

  useEffect(() => {
    !!firstShowTabKey && setHlTab(firstShowTabKey)
  }, [firstShowTabKey])

  return (
    <div className={
      `vip-home-tabs-bar ${className} ${(showSubTitle && tabItems?.some(i => i.subTitle)) ? 'vip-home-tabs-bar-with-sub-title' : ''}`
    }>
      {
        tabItems?.length > 0 && tabItems.map((tabItem, index) => (
          <div
            className={`tab-pane ${tabItem?.key === hlTab ?
              index === 0 ? 'active-first' : index === tabItems.length - 1 ? 'active-last' : 'active'
              : ''
              }  ${tabItems.length > 3 ? 'more-tabs' : ''}`}
            key={index}
            style={{
              width: `${100 / tabItems.length}%`
            }}
            onClick={() => clickTab(tabItem)}
          >
            <div className='tab-pane-title-container'>
              <div className={`title ${(tabItem?.key === 'coupon_pack' && tabItem?.key === hlTab) ? 'coupon-pack-title' : ''} ${(tabItem?.key === 'value_card' && tabItem?.key === hlTab) ? 'value-card-title' : ''}`}>
                {showIcon && <img alt='' className='tab-pane-icon' src={`${CHARGE_CDN}/chargeVip/${tabItem?.key === 'value_card' ? (tabItem?.key === hlTab ? 'value_card.png' : 'value_card_disabled.png') : (tabItem?.key === hlTab ? 'red_pack.png' : 'red_pack_disabled.png')}`} />}
                {tabItem?.title}
              </div>
              {
                tabItem?.subTitle
                &&
                showSubTitle
                &&
                <div className={`sub-title`}>{tabItem?.subTitle}</div>
              }
            </div>
          </div>
        ))
      }
    </div>
  )
})

const TitleBarCard = ({ title, tag, children, className = '', onClickTitle = () => { }, withoutTitle = false }: any) => {
  return (
    <div className={`charge-vip-title-bar-card ${className}`}>
      {!withoutTitle && <div className='title-bar' onClick={onClickTitle}>
        <div className='title'>
          <div className='prefix-block'></div>
          <div className='text'>{title}</div>
          {tag && <span className='tag'>{tag}</span>}
        </div>
        <img className='icon' alt='' src={require('../../assets/icon_right.png')} />
      </div>}
      {children}
    </div>
  )
}

const CardGoodsRow = ({ userCardList }: any) => {
  // 0-生效中 1-无效
  return (<div className="card-row">
    {userCardList?.map((item, index) => {
      const icon = item?.chargeCardStatus === 0 ? 'card_price_golden.png' : 'card_price_grey.png'
      return (
        <div className={`card ${item?.chargeCardStatus === 0 ? '' : 'invalid'}`} key={index}>
          <div className='card-item'>
            <div className='card-info'>
              <div className='card-title'>
                <img alt='' src={require(`../../assets/${icon}`)} className='card-icon' />
                充电VIP储值卡
                {item?.chargeCardStatus === 1 && <div className='card-tag'>已用完</div>}
                {item?.chargeCardStatus === 2 && <div className='card-tag'>已过期</div>}
              </div>
              <div className='card-surplus'>当前余额：{item.chargeCardValidAmt}元</div>
            </div>
            <div className='card-limit'>
              {item.chargeCardTotalAmt} <div className="unit">元</div>
            </div>
            <div className='card-bottom'>
              抵扣电费+服务费｜全天可用
            </div>
          </div>
        </div>
      )
    })}
  </div>)
}

const UserGoodsBottomText = ({ userCardList, userCouponList }: any) => {
  // 当没有电卡或者没有券包时，显示底部文案
  if ((!userCardList || userCardList?.length === 0) && (!userCouponList || userCouponList?.length === 0)) return null
  return (
    <div className='user-goods-bottom-text'>
      <img alt='' src={require('../../assets/golden_line_left_1.png')} className='icon' />
      <div className='text'>VIP券叠加储值卡·更省钱</div>
      <img alt='' src={require('../../assets/golden_line_right_1.png')} className='icon' />
    </div>
  )
}



const MemberCardBuyWrap = forwardRef(
  function Wrap({
    isbottomFixed = false,
    memberGoods,
    cardTabContent,
    buyMemberCard,
    credit,
    isXpCarOwner,
    type = 'coupon_pack',
    changeOriginMemberGoods
  }: any, ref: React.Ref<HTMLDivElement>) {
    const showCredit = isXpCarOwner || (!isXpCarOwner && credit > 0)
    if (!cardTabContent || JSON.stringify(cardTabContent) === '{}') return null
    const payModeType = payModeShowType(cardTabContent?.payMode, isXpCarOwner, credit)

    const clickBuyBtn = () => {
      const payment = payModeType === 'pure-rmb' ? '现金' :
        payModeType === 'pure-credit' ? '积分' : '现金和积分'
      buyMemberCard(cardTabContent, payment, cardTabContent.index)
    }

    return (
      <div className={`member-card-buy-wrap ${type === 'coupon_pack' ? 'coupon-pack-buy-wrap' : ''} ${type === 'value_card' ? 'value-card-buy-wrap' : ''}`} ref={ref}>
        {
          cardTabContent?.discountCouponDeduction > 0
            ?
            <div className='corner'>
              抵扣红包已减{priceFormat(cardTabContent?.discountCouponDeduction)}元
            </div>
            :
            null
        }
        <div className='buy-btn' onClick={clickBuyBtn} style={cardTabContent?.discountCouponDeduction > 0 ? { borderTopRightRadius: 0 } : {}}>
          {
            cardTabContent?.showDiscountBuy
              ?
              <div className='buy-text-container' >
                优惠购买
                {!!String(priceFormat(cardTabContent?.discountBuyPrice))?.split('.')?.[0] && <div className='buy-text-unit'>¥</div>}
                <div className='final-price-big'>{String(priceFormat(cardTabContent?.discountBuyPrice))?.split('.')?.[0] || ''}</div>
                <div className='final-price-small'>{String(priceFormat(cardTabContent?.discountBuyPrice))?.split('.')?.[1] ? `.${String(priceFormat(cardTabContent?.discountBuyPrice))?.split('.')?.[1]}` : ''}</div>
                <div className='sale-price'>{cardTabContent?.salePrice ? `¥${priceFormat(cardTabContent?.salePrice)}` : ''}</div>
              </div>
              :
              <div className='buy-text-container'>
                {
                  <>
                    购买
                    {
                      cardTabContent?.salePrice
                        ?
                        <>
                          <div className='buy-text-unit'>¥</div>
                          <div className='final-price-big'>{String(priceFormat(cardTabContent?.salePrice))?.split('.')?.[0]}</div>
                          <div className='final-price-small'>{String(priceFormat(cardTabContent?.salePrice))?.split('.')?.[1] ? `.${String(priceFormat(cardTabContent?.salePrice))?.split('.')?.[1]}` : ''}</div>
                        </>
                        :
                        null
                    }
                  </>
                }
                {/* <div className='sale-price'>{cardTabContent?.salePrice ? `¥${cardTabContent?.salePrice}` : ''}</div> */}
              </div>
          }
        </div>
        <AgreementRow
          detailRuleImgUrl={memberGoods.detailRuleImgUrl}
          credit={credit}
          isXpCarOwner={isXpCarOwner}
          memberGoods={memberGoods}
          content={cardTabContent}
          changeOriginMemberGoods={changeOriginMemberGoods}
        />
      </div>
    )
  }
)



const App = () => {
  const uid = useRef('')

  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  // 埋点字段集合
  const origin = isXPApp ? 'app' : (isWXApp || isMyApp) ? 'mini' : 'web' // 埋点来源字段 app|mini|web
  const memberTypeMap = {
    1: '1-车主无生效券包无生效电卡',
    2: '2-车主无生效券包有生效电卡',
    3: '3-车主有生效券包无生效电卡',
    4: '4-车主有生效券包有生效电卡',
    5: '5-非车主不是vip&最近30天是vip',
    6: '6-非车主非vip&最近30天不是vip',
    7: '7-非车主是vip&无生效券包无生效电卡',
    8: '8-非车主是vip&无生效券包有生效电卡',
    9: '9-非车主是vip&有生效券包无生效电卡',
    10: '10-非车主是vip&有生效券包有生效电卡'
  }
  const userMemberType = useRef(0)
  const vipMemberFlag = useRef(false) // 是否vip会员

  const [navBgWhite, setNavBgWhite] = useState(false)
  const [popupModalType, setPopupModalType] = useState<'card' | 'coupon' | ''>('')
  const [showFullScreenPopup, setShowFullScreenPopup] = useState(false)
  const [showDiscountPopup, setShowDiscountPopup] = useState(false)
  const [showSharePanel, setShowSharePanel] = useState(false)
  const [showBottomFix, setShowBottomFix] = useState(false)
  const memberCardFixRef = useRef<any>(null)
  const couponPackFixRef = useRef<any>(null)
  const navBarRef = useRef<any>(null)

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isEmptyPage, setIsEmptyPage] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [showGoodsType, setShowGoodsType] = useState(0) // 1-充电VIP券包|充电VIP电卡 3-充电VIP券包&充电VIP卡
  const [userCouponList, setUserCouponList] = useState<any[]>([]) // 用户券包列表
  const [userCardList, setUserCardList] = useState<any[]>([]) // 用户卡列表

  // 监听当前页面是否可见
  const pageVisible = useRef(true)

  const userType = useRef(0)
  const memberGoodsInfo = useRef<MemberGoods | any>()
  const [balanceCredit, setBalanceCredit] = useState(0)
  const [isXpOwner, setIsXpOwner] = useState(false)
  const [isVipMember, setIsVipMember] = useState(false)
  const isMember = isXpOwner || isVipMember
  const vipEndTimeRef = useRef(0)
  const [vipEndTime, setVipEndTime] = useState(0)
  const [xpOwnerPopupImgUrl, setXpOwnerPopupImgUrl] = useState('')
  const [discountCouponImgUrl, setDiscountCouponImgUrl] = useState('')

  const [memberGoods, setMemberGoods] = useState<MemberGoods>({
    shareImgUrl: '',
    shareMainTitle: '',
    shareSubTitle: '',
    agreementUrl: '',
    memberCardList: [],
    detailImgJumpUrlList: [],
    detailRuleImgUrl: '',
    priceImgJumpUrl: {
      imgUrl: '',
      jumpUrl: ''
    },
    homepageId: '', // VIP页面序号编码
    homepageGroupId: '', // 分组ID
    homepageGroupName: '', // 分组名称
    dmpId: '', // 分组DMP人群
    discountCouponDto: '',
    chargeCardGoodsList: [],
    couponPackGoodsList: []
  })
  const [memberCardTabItems, setMemberCardTabItems] = useState<any[]>([])
  // 2.0新增
  const [memberCardTabContent, setMemberCardTabContent] = useState<GoodsTabContent>()

  // 加购的充电VIP卡、充电VIP券包请求单独的接口，没有做身份校验，跟memberGoods接口返回的数据不一样，避免冲突，单独定义变量
  const popupModalTitle = {
    'card': '充电VIP续购',
    'coupon': '购买更多'
  }
  const [memberCardGoods, setMemberCardGoods] = useState<MemberCardGood[]>([])
  const [memberBuyCurrentTab, setMemberBuyCurrentTab] = useState<'coupon_pack' | 'value_card'>()
  const [goodsTabItems, setGoodsTabItems] = useState<any[]>([])
  const [goodsTabContent, setGoodsTabContent] = useState<GoodsTabContent>()
  const [stationList, setStationList] = useState<any[]>([])
  const [currentSelectedGood, setCurrentSelectGood] = useState<any>({})
  // 叠加活动选中商品
  const [currentSelectedMultiGood, setCurrentSelectMultiGood] = useState<any>({})
  const [userInfo, setUserInfo] = useState<any>({})

  useEffect(() => {
    // 自定义分享按钮事件（APP）
    // defineSelfShareAction(callShare)

    pageVisibleListener()

    // 小鹏APP内webview全屏
    navHide(false)

    setIsLoading(true)
    initData()

    // 延迟800ms请求附近站点，避免高德SDK加载阻塞页面渲染执行
    setTimeout(() => {
      getQueryStationList()
    }, 800)
  }, [])

  const changeTabContent = (type: 'coupon_pack' | 'value_card') => {

  }

  // 获取高德定位promise
  const getLocationGeoPro = () => {
    return new Promise(async (resolve, reject) => {
      try {
        await loadScript(
          'https://webapi.amap.com/maps?v=1.4.12&key=697eb023cbaadfdf68211c7b18165ed7',
          'vip-amap-script'
        )

        const AMap = (window as any).AMap;
        var mapObj = new AMap.Map("iCenter");
        mapObj.plugin("AMap.Geolocation", function () {
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            // timeout: 10000 // 超过10秒后停止定位，默认：无穷大
          });
          mapObj.addControl(geolocation);
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, "complete", (result) => {
            resolve({
              lng: result.position.lng,
              lat: result.position.lat,
            });
          }); // 返回定位信息
          AMap.event.addListener(geolocation, "error", (result) => {
            reject('高德定位失败');
            console.error('高德定位失败:' + result.message);
          }); // 返回定位出错信息
        });
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  };

  const getQueryStationList = async () => {
    try {
      const lnglat = await getLocationGeoPro() as { lng: number, lat: number }
      if (!lnglat?.lng || !lnglat?.lat) return
      const res: any = await GetQueryStationList({
        longitude: lnglat?.lng,
        latitude: lnglat?.lat,
        sortType: 1,
        pageNo: 1,
        pageSize: 2,
        radius: 5000
      })
      if (res.code === 200) {
        setStationList(res.data.result)
      }
    } catch (error) {
      console.log('QueryStationList error -->', error)
    }
  }

  // 如果是微信小程序/支付宝小程序，需要设置页面分享信息
  const defineShareInfoInMiniProgram = () => {
    if (isWXApp) {
      wxInit().then(wx => wx.miniProgram.postMessage({
        data: {
          shareTitle: memberGoodsInfo.current?.shareMainTitle,
          shareIcon: memberGoodsInfo.current?.shareImgUrl,
        }
      }))
    } else if (isMyApp) {
      myInit().then(my => my.postMessage({
        data: {
          shareTitle: memberGoodsInfo.current?.shareMainTitle,
          shareIcon: memberGoodsInfo.current?.shareImgUrl,
        }
      }))
    }
  }

  // 监听页面滑动，做相关页面UI逻辑处理
  const onPageScroll = (e) => {
    if (popupModalType) return
    if (e.target.scrollTop >= 300 && !navBgWhite) {
      setNavBgWhite(true)
    } else if (e.target.scrollTop < 300 && navBgWhite) {
      setNavBgWhite(false)
    }

    const navBarHeight = navBarRef.current?.clientHeight || 0
    if (memberCardFixRef.current) {
      if (isInViewPort(memberCardFixRef.current, navBarHeight)) {
        setShowBottomFix(false)
      } else {
        setShowBottomFix(true)
      }
    }

    if (couponPackFixRef.current) {
      if (isInViewPort(couponPackFixRef.current, navBarHeight)) {
        setShowBottomFix(false)
      } else {
        setShowBottomFix(true)
      }
    }
  }

  // 每次返回当前TAB需要刷新当前用户数据，可能用户已经购买VIP卡/购买券包
  const pageVisibleListener = () => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        pageVisible.current = false
      }
      if (!pageVisible.current && document.visibilityState === 'visible') {
        // document?.querySelector('.charge-vip-home')?.scrollTo(0,0)
        initData(false)
      }
    })
  }

  const initData = (init = true) => {
    getCurrentUid().then(async userId => {
      uid.current = userId
      getUserCredit()
      getUserInfo()
      getUserMembership(init)
      getMemberCardGoods()
    }).catch(err => {
      console.log('getCurrentUid error --> ', err)
    })
  }

  const getUserCredit = () => {
    return new Promise<any>(async (resolve) => {
      try {
        const res: any = await GetUserCredit()
        if (res.code === 200) {
          setBalanceCredit(res.data?.balanceCredit || 0)
        }
      } catch (error) {
        console.log('getUserCredit error -->', error)
      } finally {
        resolve(true)
      }
    })
  }

  const getUserInfo = () => {
    return new Promise<any>(async (resolve) => {
      try {
        const res: any = await getCurrentUserInfo()
        if (res.code === 200) {
          setUserInfo(res.data)
        }
      } catch (error) {
        console.log('getUserInfo error -->', error)
      } finally {
        resolve(true)
      }
    })
  }

  const getUserMembership = async (init) => {
    try {
      const res: any = await GetUserMembership({ uid: uid.current })
      if (res.code === 200) {
        const data = res.data
        userType.current = data?.userType
        vipEndTimeRef.current = data?.endTime

        // 车主身份判断
        if (data?.userType === 1) {
          setIsXpOwner(true)
        } else {
          setIsXpOwner(false)
        }

        // 非车主情况下 vip会员判断
        if (data?.userType !== 1) {
          if (data?.isMember === 1) {
            vipMemberFlag.current = true
            setIsVipMember(true)
          } else {
            vipMemberFlag.current = false
            setIsVipMember(false)
          }
        }

        // 拿到用户身份后，发起商品数据请求
        try {
          let memberGoodsRes: any = await getMemberInfo()
          let useroodRes: any = await getMemberGoods(memberGoodsRes)
          // 车主身份判断
          if (data?.userType === 1) {
            // 当前用户是车主才发起车主特权说明接口请求
            // 车主特权请求必须在优惠弹窗展示判定之后
            getXpOwnerPrivilege(useroodRes?.haveDiscount)
          }
        } catch (error) {
          console.log('getMemberInfo error -->', error)
          setIsLoading(false)
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsLoadingError(true)
        }

        setVipEndTime(data?.endTime)
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    } catch (error) {
      console.log('getUserMembership error -->', error)
      setIsLoading(false)
      setErrorMsg(DEFAULT_ERROR_MSG)
      setIsLoadingError(true)
    }
  }

  const getXpOwnerPrivilege = async (haveShowDiscount: boolean) => {
    try {
      // 如果优惠弹窗展示，不判断车主特权
      if (haveShowDiscount) return
      const res: any = await GetXpOwnerPrivilege({ uid: uid.current })
      if (res.code === 200) {
        const data = res.data
        setXpOwnerPopupImgUrl(data?.xpOwnerPopupImgUrl)
        // 前端本地缓存，单个uid单端只弹一次
        if (data?.xpOwnerPopupImgUrl) {
          const hasShownPopupUids = localStorage.getItem('hasShownPopupUids')
          if (!hasShownPopupUids) {
            setShowFullScreenPopup(true)
            localStorage.setItem('hasShownPopupUids', JSON.stringify([uid.current]))
            // 上报埋点
            trackGdp('P11222', 'B009')
          } else {
            const uidArr = JSON.parse(hasShownPopupUids)
            if (!uidArr.includes(uid.current)) {
              setShowFullScreenPopup(true)
              uidArr.push(uid.current)
              localStorage.setItem('hasShownPopupUids', JSON.stringify(uidArr))
              // 上报埋点
              trackGdp('P11222', 'B009')
            }
          }
        }
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    } catch (error) {
      console.log('getXpOwnerPrivilege error -->', error)
      setIsLoading(false)
      setErrorMsg(DEFAULT_ERROR_MSG)
      setIsLoadingError(true)
    }
  }



  const getMemberGoods = async (memberGoodsRes: any) => {
    return new Promise(async (resolve) => {
      const res: any = await GetMyMemberGoods()
      const data = res.data
      setUserCouponList(data?.userCouponList || [])
      setUserCardList(data?.userChargeCardList || [])

      const isXpCarOwner = userType.current === 1
      const hasUserCoupon = data?.userCouponList?.length > 0
      const hasChargeCard = data?.userChargeCardList?.length > 0
      let newShowGoodType = 0
      if (isXpCarOwner) {
        newShowGoodType = 1
        if ((
          (memberGoodsRes?.chargeCardGoodsList?.filter(i => i.isDiscount)?.length > 0 && hasUserCoupon)
          ||
          (memberGoodsRes?.couponPackGoodsList?.length > 0 && hasChargeCard)
        )
          &&
          !(hasChargeCard && hasUserCoupon)) {
          setCurrentSelectMultiGood((hasUserCoupon ? memberGoodsRes?.chargeCardGoodsList?.filter(i => i.isDiscount)?.[0] : memberGoodsRes?.couponPackGoodsList?.[0]))
        }
        if (!hasUserCoupon && !hasChargeCard) {
          userMemberType.current = 1
        } else if (!hasUserCoupon && hasChargeCard) {
          userMemberType.current = 2
        } else if (hasUserCoupon && !hasChargeCard) {
          userMemberType.current = 3
        } else {
          userMemberType.current = 4
        }
      } else {
        if (vipMemberFlag.current) {
          // 非车主是VIP会员
          newShowGoodType = 1
          if ((
            (memberGoodsRes?.chargeCardGoodsList?.filter(i => i.isDiscount)?.length > 0 && hasUserCoupon)
            ||
            (memberGoodsRes?.couponPackGoodsList?.length > 0 && hasChargeCard)
          )
            &&
            !(hasChargeCard && hasUserCoupon)) {
            setCurrentSelectMultiGood((hasUserCoupon ? memberGoodsRes?.chargeCardGoodsList?.filter(i => i.isDiscount)?.[0] : memberGoodsRes?.couponPackGoodsList?.[0]))
          }
          if (!hasUserCoupon && !hasChargeCard) {
            userMemberType.current = 7
          } else if (!hasUserCoupon && hasChargeCard) {
            userMemberType.current = 8
          } else if (hasUserCoupon && !hasChargeCard) {
            userMemberType.current = 9
          } else {
            userMemberType.current = 10
          }
        } else {
          newShowGoodType = 3
          const now = new Date().getTime()
          const thirtyDays = 30 * 24 * 3600 * 1000
          if (now - vipEndTimeRef.current > thirtyDays) {
            userMemberType.current = 6
          } else {
            userMemberType.current = 5
          }
        }
      }

      let haveDiscount: boolean =
        //车主会员无卡无券
        (
          isXpCarOwner
          &&
          !data?.userCouponList?.length
          &&
          !data?.userChargeCardList?.lengt
          &&
          (memberGoodsRes?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoodsRes?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon))
        )
        ||
        //车主会员有卡无券
        (
          isXpCarOwner
          &&
          !!data?.userChargeCardList?.length
          &&
          !data?.userCouponList?.length
          &&
          (memberGoodsRes?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoodsRes?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon))
        )
        ||
        //非车主会员无卡无券
        (
          vipMemberFlag.current
          &&
          !data?.userCouponList?.length
          &&
          !data?.userChargeCardList?.lengt
          &&
          (memberGoodsRes?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoodsRes?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon))
        )
        ||
        //非车主会员有卡无券
        (
          !vipMemberFlag.current
          &&
          !!data?.userChargeCardList?.length
          &&
          !data?.userCouponList?.length
          &&
          (memberGoodsRes?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoodsRes?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon))
        )
        ||
        // 非车主非会员
        (
          !isXpCarOwner
          &&
          !vipMemberFlag.current
          &&
          memberGoodsRes?.memberCardList?.some(i => i.autoReceiveDiscountCoupon)
        )
      
      setShowGoodsType(newShowGoodType)

      const hasShowDiscountPopupUids = localStorage.getItem('hasShowDiscountPopupUids')

      if (memberGoodsRes?.discountCouponDto?.couponImgUrl && haveDiscount) {
        if (!hasShowDiscountPopupUids) {
          setShowDiscountPopup(true)
          // 记录是否弹出过优惠弹窗
          localStorage.setItem('hasShowDiscountPopupUids', JSON.stringify([uid.current]))
        } else {
          const uidArr = JSON.parse(hasShowDiscountPopupUids)
          if (!uidArr.includes(uid.current)) {
            setShowDiscountPopup(true)
            // 记录是否弹出过优惠弹窗
            uidArr.push(uid.current)
            localStorage.setItem('hasShowDiscountPopupUids', JSON.stringify(uidArr))
          }
        }
      }

      trackGdp('P11222', 'B001', {
        origin,
        userType: memberTypeMap[userMemberType.current],
        'page_id': data?.homepageId,
        'group_id': data?.homepageGroupId,
        'group_name': data?.homepageGroupName,
        'group_base': (isXpCarOwner || vipMemberFlag.current) ? '充电VIP成员' : '其他新能源车主',
        'dmp_id': data?.dmpId
      })

      // 延迟300ms上报B004，这里需要看B001到B004在鼹鼠的漏斗转化率，需要严格按照次序上报
      setTimeout(() => {
        // 非车主非vip不上报B004
        if (isXpCarOwner || vipMemberFlag.current) {
          trackGdp('P11222', 'B004', {
            'group_id': memberGoodsRes?.homepageGroupId,
            'group_name': memberGoodsRes?.homepageGroupName,
            'status_code': getStatusCode(data?.userCouponList, data?.userChargeCardList, memberGoodsRes),
            'delivery_group_type': getGroupType(memberGoodsRes, data, newShowGoodType)
          })
        }
      }, 300)

      resolve({
        couponList: data?.userCouponList,
        cardList: data?.userChargeCardList,
        haveDiscount: memberGoodsRes?.discountCouponDto?.couponImgUrl && haveDiscount &&
          ((hasShowDiscountPopupUids && !JSON.parse(hasShowDiscountPopupUids)?.includes(uid.current)) || !hasShowDiscountPopupUids)
      })
    })
  }

  const getMemberInfo = async () => {
    // 获取非vip可购商品列表，拼接tab框架数据
    return new Promise(async (resolve) => {
      const res: any = await GetMemberGoods()
      if (res.code === 200) {
        setIsLoading(false)
        const data = {
          ...memberGoods,
          ...res.data
        }
        memberGoodsInfo.current = data
        defineShareInfoInMiniProgram()
        setDiscountCouponImgUrl(data?.discountCouponDto?.couponImgUrl || '')
        let newMemberGoods = { ...data }
        if (data.memberCardList?.length > 0) {
          const items: any[] = []
          data.memberCardList.forEach((item, index) => {
            items.push({
              ...item,
              key: item?.sku + index,
              id: item?.cardId,
              title: item?.mainTitle,
              subTitle: item?.subTitle,
              onClick: () => {
                setMemberCardTabContent({
                  ...item,
                  type: 'card',
                  key: item?.sku + index,
                  index,
                  id: item?.cardId,
                })
              }
            })
          })
          setMemberCardTabItems(items)
          setMemberCardTabContent({
            ...(data?.memberCardList?.[0] || {}),
            type: 'card',
            index: 0,
            key: data.memberCardList[0]?.sku + '0',
            id: data.memberCardList[0]?.cardId,
          })
          newMemberGoods.memberCardList = items
        } else {
          let tabItems: any = []
          !!data?.couponPackGoodsList?.length && (tabItems.push({
            type: 'coupon_pack',
            key: 'coupon_pack',
            title: 'VIP券包',
            onClick: () => changeTabContent('coupon_pack')
          }))
          !!data?.chargeCardGoodsList?.length && (tabItems.push({
            type: 'value_card',
            key: 'value_card',
            title: 'VIP储值卡',
            onClick: () => changeTabContent('value_card')
          }))
          setMemberCardTabItems(tabItems)
          let newCouponPacklist = data?.couponPackGoodsList?.map((item, index) => {
            return {
              ...item,
              key: `${item.spu}-${index}`
            }
          })
          let newValueCardList = data?.chargeCardGoodsList?.map((item, index) => {
            return {
              ...item,
              key: `${item.spu}-${index}`
            }
          })
          let currentGood =
            (data?.priorGoodsType === 2)
              ?
              (newCouponPacklist?.[0])
              :
              (data?.priorGoodsType === 3 ? newValueCardList?.[0] : null)
          setCurrentSelectGood(
            currentGood
              ? {
                ...currentGood
              }
              :
              {
                ...(newCouponPacklist?.[0] || {}),
              }
          )
          setMemberBuyCurrentTab(data?.priorGoodsType === 2 ? 'coupon_pack' : (data?.priorGoodsType === 3 ? 'value_card' : 'coupon_pack'))

          newMemberGoods.chargeCardGoodsList = newValueCardList
          newMemberGoods.couponPackGoodsList = newCouponPacklist
        }
        setMemberGoods(newMemberGoods)
        resolve(newMemberGoods)
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    })
  }

  const showRenewGoods = (type: 'card' | 'coupon') => {
    const goods: any[] = type === 'card' ? memberCardGoods : memberGoods.couponPackGoodsList.concat(memberGoods.chargeCardGoodsList)
    const id = type === 'card' ? memberCardGoods[0]?.cardId : memberGoods.couponPackGoodsList.concat(memberGoods.chargeCardGoodsList)[0]?.couponPackId
    const buttonId = type === 'card' ? 'B002' : 'B006'

    // 先判断当前可续购的充电VIP卡/券包是否为空，兜底toast
    if (!goods || goods.length === 0) {
      showToast('非常抱歉，当前已抢完~')
      return
    }

    if (type === 'card') {
      const tabItems = goods.map((item, index) => {
        return {
          ...item,
          key: item?.sku + index,
          id: item?.cardId,
          title: item?.mainTitle,
          subTitle: item?.subTitle,
          isRenew: true,
          onClick: () => {
            setGoodsTabContent({
              ...item,
              type,
              key: item?.sku + index,
              id: item?.cardId,
              index,
              isRenew: true
            })

            // 上报埋点
            trackGdp('P11222', buttonId, {
              goodId: item?.cardId,
              'group_id': memberGoods?.homepageGroupId,
              'group_name': memberGoods?.homepageGroupName,
              'delivery_group_type': getGroupType(memberGoods, { couponPackGoodsList: userCouponList, chargeCardGoodsList: userCardList }, showGoodsType),
            })
          }
        }
      })
      setGoodsTabItems(tabItems)
      setGoodsTabContent({
        ...(goods?.[0] || {}),
        type,
        key: goods[0]?.sku + '0',
        id,
        index: 0,
        isRenew: true
      })
    }

    setPopupModalType(type)

    // 上报埋点
    trackGdp('P11222', buttonId, {
      goodId: id,
      'group_id': memberGoods?.homepageGroupId,
      'group_name': memberGoods?.homepageGroupName,
      'delivery_group_type': getGroupType(memberGoods, { couponPackGoodsList: userCouponList, chargeCardGoodsList: userCardList }, showGoodsType),
    })
  }

  const getStatusCode = (couponList = null, cardList = null, newMemberGoods: any = null) => {
    if (!newMemberGoods) { newMemberGoods = memberGoods }
    const CouponList = couponList || userCouponList
    const CardList = cardList || userCardList
    // 获取已购买的充电VIP卡/券包
    const hasCard = CardList?.length || 0 > 0
    const hasCoupon = CouponList?.length || 0 > 0
    // 获取可购买列表中的充电VIP卡/券包
    const hasCardGoods = !!newMemberGoods?.chargeCardGoodsList?.length
    const hasCouponGoods = !!newMemberGoods?.couponPackGoodsList?.length
    // 属性上报枚举值:VIP产品模块状态
    // i.状态1(引导购买VIP券包和VIP电卡)
    // ii.状态2(引导核销VIP电卡+购买券包)
    // iii.状态3(引导核销VIP券包和购买电卡)
    // iv.状态4(引导核销VIP券包和VIP电卡)
    // V.状态5(引导核销VIP券包)
    // vi.状态6(引导核销VIP电卡)

    if (!hasCard && !hasCoupon) {
      return '状态1（引导购买VIP券包和VIP电卡）'
    } else if (hasCard && hasCouponGoods && !hasCoupon) {
      return '状态2（引导核销VIP电卡+购买券包）'
    } else if (hasCoupon && hasCardGoods && !hasCard) {
      return '状态3（引导核销VIP券包和购买电卡）'
    } else if (hasCoupon && hasCard) {
      return '状态4（引导核销VIP券包和VIP电卡）'
    } else if (hasCoupon && !hasCard && !hasCardGoods) {
      return '状态5（引导核销VIP券包）'
    } else if (hasCard && !hasCoupon && !hasCouponGoods) {
      return '状态6（引导核销VIP电卡）'
    } else {
      return ''
    }
  }

  const getBtnType = (good) => {
    // CHARGING_STORE_VALUE_CARD VIP电卡
    // CHARGE_COUPON_PACK VIP券包
    return good.goodsClass === 'CHARGING_STORE_VALUE_CARD' ? 'VIP电卡' : good.goodsClass === 'CHARGE_COUPON_PACK' ? 'VIP券包' : ''
  }

  const getMemberCardGoods = async () => {
    try {
      const res: any = await GetMemberCardGoods({ uid: uid.current })
      if (res.code === 200) {
        const memberCardList = res.data?.memberCardList
        setMemberCardGoods(memberCardList)
      } else {
        // 不做处理
      }
    } catch (error) {
      console.log('getMemberCardGoods error -->', error)
    }
  }


  const buyMemberCard = (good, payment, order, isMore?: boolean) => {
    let isCard: boolean = good?.goodsClass === 'CHARGE_SAVE_MONEY'
    const isXpCarOwner = userType.current === 1
    if (isCard) {
      good.vipGoodsId = good.cardId
    } else {
      // 非车主非vip不上报埋点
      if (!good?.isRenew && !isMore) {
        if (!isXpCarOwner && !vipMemberFlag.current) {
          doBuyMemberGoods(good)
          return
        }
      }
    }
    if (isCard) {
      // 上报埋点
      trackGdp('P11222', good?.isRenew ? 'B003' : 'B012', {
        goodId: good.vipGoodsId,
        payment,
        userType: memberTypeMap[userMemberType.current],
        order: order + 1,
        'status_code': getStatusCode(),
        'group_id': memberGoods?.homepageGroupId,
        'group_name': memberGoods?.homepageGroupName,
        'delivery_group_type': getGroupType(memberGoods, { couponPackGoodsList: userCouponList, chargeCardGoodsList: userCardList }, showGoodsType),
        'points_type': getPointsType(good),
        'unit_price_type': getUnitPriceType(good),
        'mall_coupon': `${memberGoods?.discountCouponDto?.couponPlanName}(${memberGoods?.discountCouponDto?.couponPlanId})`,
        'system_mall_coupon': getSystemMallCoupon(good)
      })
    } else {
      // 上报埋点
      trackGdp('P11222', good?.isRenew ? 'B003' : (isMore ? 'B007' : 'B005'), {
        goodId: good.vipGoodsId,
        payment,
        userType: memberTypeMap[userMemberType.current],
        order: order + 1,
        btnType: getBtnType(good),
        'status_code': getStatusCode(),
        'group_id': memberGoods?.homepageGroupId,
        'group_name': memberGoods?.homepageGroupName,
        'delivery_group_type': getGroupType(memberGoods, { couponPackGoodsList: userCouponList, chargeCardGoodsList: userCardList }, showGoodsType),
        'points_type': getPointsType(good),
        'unit_price_type': getUnitPriceType(good),
        'mall_coupon': `${memberGoods?.discountCouponDto?.couponPlanName}(${memberGoods?.discountCouponDto?.couponPlanId})`,
        'system_mall_coupon': getSystemMallCoupon(good)
      })
    }
    doBuyMemberGoods(good)
  }


  const doBuyMemberGoods = async (good: {
    autoReceiveDiscountCoupon: any;
    vipGoodsId: string
    goodsClass: string
    sku: string
    spu: string
    id: string
  }) => {
    try {
      const params = {
        uid: uid.current,
        bizCode: good?.vipGoodsId || good?.id,
        goodsClass: good.goodsClass,
        sku: good.sku,
        spu: good.spu,
        discountCouponPlanId: good?.autoReceiveDiscountCoupon ? memberGoods?.discountCouponDto?.couponPlanId : undefined
      }
      const res: any = await PostPreBuyMemberGoods(params)
      if (res.code === 200) {
        if (res.data?.orderUrl) {
          goToPage(`${res.data?.orderUrl}?entry=${MALL_ENTRY}`, {}, P_MALL_APPID)
        }
      } else {
        showToast(res?.msg)
      }
    } catch (error) {
      console.log('doBuyMemberGood -->', error)
      showToast(DEFAULT_ERROR_MSG)
    }
  }

  const goToRecord = () => {
    // 上报埋点
    trackGdp('P11222', 'B011')

    const { origin, pathname } = window.location
    goToPage(`${origin}${pathname}#/record`)
  }

  const goToPrivilege = (tab: string) => {
    const { origin, pathname } = window.location
    goToPage(`${origin}${pathname}#/privilege?tab=${tab}`)
  }

  /**
   * 跳转到APP/小程序的【充电卡包-充电券】页面，若当前环境是其他浏览器，则提示“请下载小鹏APP查看充电卡券”
   */
  const goToMyCouponPage = () => {
    if (isXPApp) {
      jumpPage('xiaopeng://charging/card?type=1', {})
    } else if (isWXApp) {
      wxInit().then(wx => wx.miniProgram.navigateTo({ url: '/charging/pages/voucher-list/index?tabIndex=1' }))
    } else if (isMyApp) {
      myInit().then(my => my.navigateTo({ url: '/charging/pages/voucher-list/index?tabIndex=1' }))
    } else {
      showToast('请下载小鹏APP查看充电卡券')
    }

    // 上报埋点
    trackGdp('P11222', 'B010')
  }

  const gotoCharge = () => {
    if (isXPApp) {
      jumpPage('xiaopeng://charging/manageNew', {})
    } else if (isWXApp) {
      wxInit().then(wx =>
        wx.miniProgram.switchTab({
          url: `/pages/station-list/index`
        })
      );
    } else if (isMyApp) {
      myInit().then(my =>
        my.switchTab({
          url: `/pages/station-list/index`
        })
      );
    } else {
      showToast('请下载小鹏APP查看')
    }
  };

  const showToast = (text: string) => {
    Toast.show({
      text,
      duration: 2000
    });
  }

  const callShare = () => {
    // 2023-10-31 改为分享小程序，H5自行编写分享面板
    try {
      setShowSharePanel(true)
      // 上报埋点
      trackGdp('P11222', 'B008')
    } catch (error) {
      console.log('callShare error-->', error)
    }
  }

  if (isLoading)
    return (
      <LoadingPage />
    )

  if (isLoadingError)
    return (
      <ErrorPlaceholder
        message={errorMsg}
      ></ErrorPlaceholder>
    )

  if (isEmptyPage)
    return (
      <EmptyPlaceholder text={errorMsg}></EmptyPlaceholder>
    )

  const {
    detailImgJumpUrlList,
    priceImgJumpUrl,
  } = memberGoods


  const getAvailableTime = (startTime: string, endTime: string) => {
    if (!startTime || !endTime) return ''

    if (startTime === '00:00' && endTime === '24:00') {
      return '全天可用'
    }

    // 正常来说全天只有上面这种小时和分钟的情况，怕数据没全部更新，加个兜底
    if (startTime === '00:00:00' && endTime === '23:59:59') {
      return '全天可用'
    }

    const startHour = +startTime.split(':')[0]
    const endHour = +endTime.split(':')[0]
    return `${startHour}-${endHour}点可用`
  }


  return (
    <div
      className='charge-vip-home'
      onScroll={onPageScroll}
    >
      <OpenBar title='小鹏充电VIP' />
      {
        isXPApp &&
        <NavBar bgWhite={navBgWhite} callShare={callShare} ref={navBarRef} />
      }
      <div
        className={`page-content ${isXPApp ? 'isXpApp' : ''}`}
        style={
          showBottomFix ?
            (
              showGoodsType === 1 ? { paddingBottom: couponPackFixRef.current?.clientHeight + 60 }
                : showGoodsType === 3 ? { paddingBottom: memberCardFixRef.current?.clientHeight + 60 }
                  : {}
            ) : {}
        }
      >
        <div className='id-card'>
          <div className='top-wrap' style={isMember && isXpOwner ? { alignItems: 'center' } : {}}>
            <div className='user-info'>
              <img src={userInfo?.headImg || `${CHARGE_CDN}/common/unlogin-avator.png`} className='user-avator' alt="" />
              <div className='user-name-wrap'>
                <div className='user-name'>
                  {userInfo?.nickName || '--'}
                  {
                    isXpOwner
                      ?
                      <img src={`${CHARGE_CDN}/chargeVip/all_life_vip.png`} alt="" className='all-life-vip-tag' />
                      :
                      (
                        isVipMember
                          ?
                          <img src={`${CHARGE_CDN}/chargeVip/temp_vip.png`} alt="" className='temp-vip-tag' />
                          :
                          null
                      )
                  }
                </div>
                <div className='user-limit-time' onClick={() => {
                  if (!isXpOwner && isVipMember) {
                    goToRecord()
                  }
                }}>
                  {!isMember ? '当前非充电VIP会员' : (isXpOwner ? '' : `VIP有效期：${formatTs(vipEndTime, 'YYYY-MM-DD')}`)}
                  {(!isXpOwner && isVipMember) && <img src={`${CHARGE_CDN}/chargeVip/light_color_arrow.png`} className='user-limit-time-arrow' alt="" />}
                </div>
              </div>
            </div>
            <div className='right-action-trigger'>
              {!isXpOwner && isVipMember
                ?
                <div className='renew-btn' onClick={() => showRenewGoods('card')}>立即续期</div>
                :
                <div className='records-wrap' onClick={goToRecord}>
                  <img src={`${CHARGE_CDN}/chargeVip/records.png`} className='records-icon' alt="" />
                  获得记录
                </div>}
            </div>
          </div>
          {
            isMember
            &&
            <div className='bottom-wrap'>
              <div className='vip-desc-item' onClick={() => goToPrivilege('coupon')}>
                <img className='vip-desc-icon' src={`${CHARGE_CDN}/chargeVip/buy.png`} alt="" />
                购VIP券包
              </div>
              <div className='vip-desc-item' onClick={() => goToPrivilege('price')}>
                <img className='vip-desc-icon' src={`${CHARGE_CDN}/chargeVip/enjoy.png`} alt="" />
                享VIP专享价
              </div>
              <div className='vip-desc-item' onClick={() => goToPrivilege('campaign')}>
                <img className='vip-desc-icon' src={`${CHARGE_CDN}/chargeVip/activity.png`} alt="" />
                VIP专属活动
              </div>
            </div>
          }
        </div>
        {
          showGoodsType === 1 && (userCouponList?.length > 0 || userCardList?.length > 0) ? (
            <div>
              <div className='coupon-card-gap'
                onScroll={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}></div>
              <TitleBarCard title='VIP权益·已购产品' className='coupon-card' onClickTitle={() => goToPrivilege('coupon')}>
                <div
                  className='user-coupon-wrap'
                  onScroll={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}>
                  {userCardList?.length ? <CardGoodsRow userCardList={userCardList} /> : null}
                  <div
                    className={`coupon-row
                   ${userCouponList?.length === 1 ? 'single' : userCouponList?.length === 2 ? 'double' : ''} 
                  ${(userCardList?.length > 0 && userCouponList?.length > 1) ? 'double-with-card' : ''}`}
                    onScroll={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    {
                      userCouponList?.map((item, index) => (
                        <div key={index}>
                          {
                            // couponStatus	优惠券状态 | 1-已领取 2-已使用 3-锁定 4-过期 5-销毁
                            // 1、3服务端统一返回1，用金色样式；2、4用灰色样式；5服务端不返回
                            [1].includes(item?.couponStatus) ? (
                              <>
                                {
                                  // 已拥有的待使用券包只有一个时，单独展示一个卡片样式 
                                  userCouponList?.length === 1 ? (
                                    <div className='coupon-item'>
                                      <div className='coupon-pack-single'>
                                        <div className='info'>
                                          <span className='unit'>¥ </span>
                                          <span className='num'>{formatPrice(item?.couponFee, 0)}</span>
                                          {
                                            item?.couponNum > 1 && (
                                              <>
                                                <span className='multi'> × </span>
                                                <span className='num'>{item?.couponNum}</span>
                                                <span className='unit'> 张</span>
                                              </>
                                            )
                                          }
                                        </div>
                                        <div className='title'>
                                          <div className='name'>充电VIP券</div>
                                          <div className='desc'>
                                            {item?.thresholdPrice ? `服务费满${formatPrice(item?.thresholdPrice, 0)}元` : '无门槛'}
                                            {getAvailableTime(item.canUseStartTime, item.canUseEndTime) && ` | ${getAvailableTime(item.canUseStartTime, item.canUseEndTime)}`}
                                          </div>
                                        </div>
                                      </div>
                                      <div className='status'>{item?.couponStatusName}</div>
                                    </div>
                                  ) :
                                    (
                                      <div className='coupon-item'>
                                        <div className='coupon-pack'>
                                          <div className='name'>充电VIP券</div>
                                          <div className='info'>
                                            <span className='unit'>¥ </span>
                                            <span className='num'>{formatPrice(item?.couponFee, 0)}</span>
                                            {
                                              item?.couponNum > 1 && (
                                                <>
                                                  <span className='multi'> × </span>
                                                  <span className='num'>{item?.couponNum}</span>
                                                  <span className='unit'> 张</span>
                                                </>
                                              )
                                            }
                                          </div>
                                          <div className='desc'>
                                            {
                                              item?.thresholdPrice ?
                                                <span className='threshold'>服务费满{formatPrice(item?.thresholdPrice, 0)}元</span> :
                                                <span className='threshold'>无门槛</span>
                                            }
                                            <div>{getAvailableTime(item.canUseStartTime, item.canUseEndTime)}</div>
                                          </div>
                                        </div>
                                        <div className='status'>{item?.couponStatusName}</div>
                                      </div>
                                    )
                                }
                              </>
                            ) : (
                              <div className='coupon-item-invalid'>
                                <div className='coupon-pack'>
                                  <div className='name'>充电VIP券</div>
                                  <div className='info'>
                                    <span className='unit'>¥ </span>
                                    <span className='num'>{formatPrice(item?.couponFee, 0)}</span>
                                    {
                                      item?.couponNum > 1 && (
                                        <>
                                          <span className='multi'> × </span>
                                          <span className='num'>{item?.couponNum}</span>
                                          <span className='unit'> 张</span>
                                        </>
                                      )
                                    }
                                  </div>
                                  <div className='desc'>
                                    {
                                      item?.thresholdPrice ?
                                        <span className='threshold'>服务费满{formatPrice(item?.thresholdPrice, 0)}元</span> :
                                        <span className='threshold'>无门槛</span>
                                    }
                                    <div>{getAvailableTime(item.canUseStartTime, item.canUseEndTime)}</div>
                                  </div>
                                </div>
                                <div className='status'>{item?.couponStatusName}</div>
                              </div>
                            )
                          }
                        </div>
                      ))
                    }
                  </div>
                  <div className='devide-line'></div>
                  <div className='btn-group'>
                    <div className='buy-btn-plain' onClick={() => showRenewGoods('coupon')}>
                      <img alt='' src={require('../../assets/cart_golden.png')} className='icon' />
                      <span className='text'>购买更多</span>
                    </div>
                    <div className='devide-line'></div>
                    <div className='buy-btn-plain' onClick={goToMyCouponPage}>
                      <img alt='' src={require('../../assets/card_golden.png')} className='icon' />
                      <span className='text'>我的充电卡券</span>
                    </div>
                  </div>
                </div>
              </TitleBarCard>
            </div>
          ) : null
        }

        {/* 非vip会员展示可购买产品 */}
        {
          (showGoodsType === 3 && memberCardTabItems?.length > 0) ? (
            <>
              <div className='member-card'>
                <TabsBar tabItems={memberCardTabItems} firstShowTabKey={memberCardTabContent?.key} showSubTitle={memberCardTabItems.length <= 3} />
                <img alt='' className='desc-img' src={memberCardTabContent?.introduceImgUrl} />
                <div className='member-card-buy-wrap-container'>
                  <MemberCardBuyWrap
                    ref={memberCardFixRef}
                    memberGoods={memberGoods}
                    cardTabContent={memberCardTabContent}
                    buyMemberCard={buyMemberCard}
                    credit={balanceCredit}
                    isXpCarOwner={isXpOwner}
                    changeOriginMemberGoods={data => setMemberGoods(data)}
                  />
                </div>
              </div>
              <div className='bottom-gap-container'>
                <div className='bottom-gap'></div>
              </div>
            </>
          ) : null
        }


        {/* vip会员展示可购买产品 */}
        {
          (showGoodsType === 1 && (memberGoods?.couponPackGoodsList?.length > 0 || memberGoods?.chargeCardGoodsList?.length > 0) && userCouponList?.length === 0 && userCardList?.length === 0) ? (
            <>
              <div className='member-card'>
                <TabsBar
                  showIcon={true}
                  tabItems={memberCardTabItems}
                  firstShowTabKey={memberBuyCurrentTab}
                  showSubTitle={memberCardTabItems.length <= 3}
                  changeActiveTab={(tab) => {
                    if (memberGoods?.couponPackGoodsList?.[0] || memberGoods?.chargeCardGoodsList?.[0]) {
                      setCurrentSelectGood(tab === 'coupon_pack' ? memberGoods?.couponPackGoodsList?.[0] : memberGoods?.chargeCardGoodsList?.[0])
                    }
                    setMemberBuyCurrentTab(tab)
                  }
                  }
                />
                <MemberGoodslist
                  list={memberBuyCurrentTab === 'coupon_pack' ? memberGoods?.couponPackGoodsList : memberGoods?.chargeCardGoodsList}
                  type={memberBuyCurrentTab}
                  active={currentSelectedGood}
                  key={memberBuyCurrentTab === 'coupon_pack' ? 'coupon_pack_scroll' : 'value_card_scroll'}
                  onChange={(data) => setCurrentSelectGood(data)}
                  label={memberGoods?.discountCouponDto?.couponLabel}
                />
                <div className='member-card-buy-wrap-container'>
                  <MemberCardBuyWrap
                    ref={couponPackFixRef}
                    memberGoods={memberGoods}
                    cardTabContent={currentSelectedGood}
                    buyMemberCard={buyMemberCard}
                    credit={balanceCredit}
                    isXpCarOwner={isXpOwner}
                    type={memberBuyCurrentTab}
                    changeOriginMemberGoods={data => {
                      //重置membergoods数据的同时要把当前的数据也重置
                      setCurrentSelectGood((memberBuyCurrentTab === 'coupon_pack' ? data?.couponPackGoodsList : data?.chargeCardGoodsList).find(i => i?.key === currentSelectedGood?.key))
                      setMemberGoods(data)
                    }}
                  />
                </div>
              </div>
              <div className='bottom-gap-container'
                onScroll={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}>
                <div className='bottom-gap'></div>
              </div>
            </>
          ) : null
        }
        {
          (showGoodsType === 1
            &&
            (
              (memberGoods?.chargeCardGoodsList?.filter(i => i.isDiscount)?.length > 0 && userCouponList.length > 0)
              ||
              (memberGoods?.couponPackGoodsList?.length > 0 && userCardList.length > 0)
            )
            &&
            !(userCardList.length > 0 && userCouponList.length > 0)
          )
            ?
            (
              <TitleBarCard title='权益·VIP专享购' tag={isXpOwner ? '车主积分全额兑' : ''} className='shopping-card' onClickTitle={() => goToPrivilege('coupon')} withoutTitle={!(!userCardList && !userCouponList)}>
                <UserGoodsBottomText userCardList={userCardList} userCouponList={userCouponList} />
                <div className='add-activity-container'>
                  <div className='add-activity-title'>限时叠加活动</div>
                  <ShortMemberGoodslist
                    list={userCouponList.length > 0 ? memberGoods?.chargeCardGoodsList?.filter(i => i.isDiscount) : memberGoods?.couponPackGoodsList}
                    type={userCouponList.length > 0 ? 'value_card' : 'coupon_pack'}
                    active={currentSelectedMultiGood}
                    onChange={(data) => setCurrentSelectMultiGood(data)}
                  />
                  <div className='buy-wrap'>
                    <MemberCardBuyWrap
                      memberGoods={memberGoods}
                      cardTabContent={currentSelectedMultiGood}
                      buyMemberCard={buyMemberCard}
                      credit={balanceCredit}
                      isXpCarOwner={isXpOwner}
                      type={userCouponList.length > 0 ? 'value_card' : 'coupon_pack'}
                      changeOriginMemberGoods={data => {
                        //重置membergoods数据的同时要把当前的数据也重置
                        setMemberGoods(data)
                      }}
                    />
                  </div>
                </div>
              </TitleBarCard>
            ) : null
        }
        {
          isMember ? (
            <TitleBarCard title='权益·VIP专享价' tag={isXpOwner ? '车主终身可享' : '叠加VIP券使用更省钱'} className='price-card' onClickTitle={() => goToPrivilege('price')}>
              {stationList.length ?
                <div className='station-list'>
                  {stationList.map((item, index) => {
                    return (
                      <div className='station-content' key={index}>
                        <StationDetailItem station={item} withLine={false} showDistance={true} />
                      </div>
                    )
                  })}
                  <div onClick={gotoCharge} className="station-tip">{'查看更多VIP专享价的场站 >'}</div>
                </div> :
                <img alt='' className='desc-img' src={priceImgJumpUrl?.imgUrl} onClick={() => goToPage(priceImgJumpUrl?.jumpUrl)} />}
            </TitleBarCard>
          ) : null
        }
        <div
          className='desc-images'
          onScroll={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}>
          {
            detailImgJumpUrlList?.length > 0 && detailImgJumpUrlList.map((item, index) => (
              <img className='image' key={index} alt='' src={item?.imgUrl} onClick={() => goToPage(item?.jumpUrl)} />
            ))
          }
        </div>
        <div className='bottom-fix-position'
          onScroll={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}>
          {
            (showGoodsType === 1 && showBottomFix && (memberGoods?.couponPackGoodsList?.length > 0 || memberGoods?.chargeCardGoodsList?.length > 0) && userCouponList?.length === 0 && userCardList?.length === 0)
            && (
              <div className='member-card-buy-wrap-container'>
                <MemberCardBuyWrap
                  memberGoods={memberGoods}
                  cardTabContent={currentSelectedGood}
                  buyMemberCard={buyMemberCard}
                  credit={balanceCredit}
                  isXpCarOwner={isXpOwner}
                  type={memberBuyCurrentTab}
                  changeOriginMemberGoods={data => {
                    //重置membergoods数据的同时要把当前的数据也重置
                    setCurrentSelectGood((memberBuyCurrentTab === 'coupon_pack' ? data?.couponPackGoodsList : data?.chargeCardGoodsList).find(i => i?.key === currentSelectedGood?.key))
                    setMemberGoods(data)
                  }}
                />
              </div>
            )
          }
          {
            (showGoodsType === 3 && showBottomFix && memberGoods?.memberCardList?.length > 0 && userCouponList?.length === 0 && userCardList?.length === 0)
            && (
              <div className='member-card-buy-wrap-container'>
                <MemberCardBuyWrap
                  memberGoods={memberGoods}
                  cardTabContent={memberCardTabContent}
                  buyMemberCard={buyMemberCard}
                  credit={balanceCredit}
                  isXpCarOwner={isXpOwner}
                  changeOriginMemberGoods={data => setMemberGoods(data)}
                />
              </div>
            )
          }
        </div>
      </div>
      <PopupBottomModal
        visible={['card', 'coupon'].includes(popupModalType)}
        title={popupModalTitle[popupModalType]}
        onClose={() => setPopupModalType('')}
        contentClassName='popup-bottom-modal-content'
        pageClassName='charge-vip-home'
      >
        <div
          className='container'
          onScroll={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}>
          {
            popupModalType === 'card' && goodsTabItems?.length > 0 ? (
              <>
                <TabsBar
                  className='vip-home-tabs-bar-with-shadow'
                  tabItems={goodsTabItems}
                  firstShowTabKey={goodsTabContent?.key}
                  showSubTitle={goodsTabItems.length <= 3}
                />
                <div className='tab-content'>
                  <img className='desc-img' src={goodsTabContent?.introduceImgUrl} alt='' />
                  <MemberCardBuyWrap
                    memberGoods={memberGoods}
                    cardTabContent={goodsTabContent}
                    buyMemberCard={(good, payment, order) => buyMemberCard(good, payment, order, true)}
                    credit={balanceCredit}
                    isXpCarOwner={isXpOwner}
                    changeOriginMemberGoods={data => setMemberGoods(data)}
                  />
                </div>
              </>
            ) : null
          }
          {
            popupModalType === 'coupon' && (memberGoods?.chargeCardGoodsList?.length > 0 || memberGoods?.couponPackGoodsList?.length > 0) ?
              <>
                <div className='member-card'>
                  <TabsBar
                    showIcon={true}
                    tabItems={memberCardTabItems}
                    firstShowTabKey={memberBuyCurrentTab}
                    showSubTitle={memberCardTabItems.length <= 3}
                    className='vip-home-tabs-bar-with-shadow'
                    changeActiveTab={(tab) => {
                      if (memberGoods?.couponPackGoodsList?.[0] || memberGoods?.chargeCardGoodsList?.[0]) {
                        setCurrentSelectGood(tab === 'coupon_pack' ? memberGoods?.couponPackGoodsList?.[0] : memberGoods?.chargeCardGoodsList?.[0])
                      }
                      setMemberBuyCurrentTab(tab)
                    }
                    }
                  />
                  <MemberGoodslist
                    list={memberBuyCurrentTab === 'coupon_pack' ? memberGoods?.couponPackGoodsList : memberGoods?.chargeCardGoodsList}
                    type={memberBuyCurrentTab}
                    active={currentSelectedGood}
                    key={memberBuyCurrentTab === 'coupon_pack' ? 'coupon_pack_scroll' : 'value_card_scroll'}
                    onChange={(data) => setCurrentSelectGood(data)}
                    label={memberGoods?.discountCouponDto?.couponLabel}
                  />
                  <div className='member-card-buy-wrap-container'>
                    <MemberCardBuyWrap
                      memberGoods={memberGoods}
                      cardTabContent={currentSelectedGood}
                      buyMemberCard={(good, payment, order) => buyMemberCard(good, payment, order, true)}
                      credit={balanceCredit}
                      isXpCarOwner={isXpOwner}
                      type={memberBuyCurrentTab}
                      changeOriginMemberGoods={data => {
                        //重置membergoods数据的同时要把当前的数据也重置
                        setCurrentSelectGood((memberBuyCurrentTab === 'coupon_pack' ? data?.couponPackGoodsList : data?.chargeCardGoodsList).find(i => i?.key === currentSelectedGood?.key))
                        setMemberGoods(data)
                      }}
                    />
                  </div>
                </div>
                <div className='bottom-gap'
                  onScroll={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}></div>
              </> : null
          }
        </div>
      </PopupBottomModal>
      <FullScreenPopup
        show={showFullScreenPopup}
        onClose={() => setShowFullScreenPopup(false)}
        imgUrl={xpOwnerPopupImgUrl}
      />
      <FullScreenPopup
        show={showDiscountPopup}
        onClose={() => setShowDiscountPopup(false)}
        imgUrl={discountCouponImgUrl}
      />
      <SharePanel
        visible={showSharePanel}
        onClose={() => setShowSharePanel(false)}
        shareInfo={memberGoodsInfo.current}
      />
    </div>
  )
}

export default App